/**
 * Datas do contrato de experiência no frontend. A regra que vale é a do backend
 * (`contract-versions.rules.ts`); aqui só o que a tela precisa para mostrar o
 * estado e preencher o atalho 45 + 45.
 */

const DAY_MS = 24 * 60 * 60 * 1000;

/** `YYYY-MM-DD` + dias, em UTC (datas civis). */
export const addDaysIso = (iso: string, days: number): string => {
  const date = new Date(`${iso.slice(0, 10)}T00:00:00.000Z`);
  return new Date(date.getTime() + days * DAY_MS).toISOString().slice(0, 10);
};

/** Hoje como data civil local (`YYYY-MM-DD`). */
export const todayIso = (): string => {
  const now = new Date();
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};

/** 45 + 45 contando o dia da admissão: 1º período até admissão + 44, fim em admissão + 89. */
export const probation45Plus45 = (admissionIso: string) => ({
  probationFirstEndDate: addDaysIso(admissionIso, 44),
  probationEndDate: addDaysIso(admissionIso, 89),
});

export type ProbationState = "NAO_E_EXPERIENCIA" | "PRIMEIRO_PERIODO" | "PRORROGACAO" | "ENCERRADA";

export const probationStateOf = (
  contract: { probationFirstEndDate?: string | null; probationEndDate?: string | null },
  todayDate: string = todayIso()
): ProbationState => {
  const end = contract.probationEndDate?.slice(0, 10);
  const first = contract.probationFirstEndDate?.slice(0, 10);
  if (!end) return "NAO_E_EXPERIENCIA";
  if (todayDate > end) return "ENCERRADA";
  if (first && todayDate > first) return "PRORROGACAO";
  return "PRIMEIRO_PERIODO";
};

export const PROBATION_STATE_LABELS: Record<ProbationState, string> = {
  NAO_E_EXPERIENCIA: "Sem experiência",
  PRIMEIRO_PERIODO: "Em experiência",
  PRORROGACAO: "Experiência prorrogada",
  ENCERRADA: "Experiência encerrada",
};
